var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ov d-flex flex-column align-items-center",class:_vm.cls},[_vm._t("default"),_c('div',{staticClass:"ov__index",class:_vm.status ? '_done': ''},[_vm._v(_vm._s(_vm.index))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }